import React from "react";
import { ReactComponent as AdministrationIcon } from "@assets/icon/administration.svg";
import { ReactComponent as TranslationsIcon } from "@assets/icon/language.svg";
import { ReactComponent as EducationalIcon } from "@assets/icon/Educational.svg";
import { ReactComponent as LearningIcon } from "@assets/icon/learning.svg";
import { ReactComponent as SettingsIcon } from "@assets/icon/settings.svg";
import { ReactComponent as DashboardIcon } from "@assets/icon/dashboard.svg";
import { ReactComponent as HRIcon } from "@assets/icon/wrapper.svg";
import { ReactComponent as StudentIcon } from "@assets/icon/student.svg";
import { RouterPaths } from "../../router/routerPaths";
import { useTranslation } from "react-i18next";

export const MenuItems = () => {
    const { t } = useTranslation();
    const role = localStorage.getItem("user_role") || "";

    const menuItems = [
        {
            key: 1,
            label: t("titles.dashboard"),
            icon: <DashboardIcon width={20} height={20} />,
            link: `${RouterPaths.DASHBOARD}`,
        },
        {
            key: 2,
            label: t("titles.administration"),
            icon: <AdministrationIcon width={20} height={20} />,
            children: [
                {
                    key: 3,
                    label: t("titles.educational_institution"),
                    link: `${RouterPaths.EDUACTIONALINSTITUTE}`,
                },
                {
                    key: 4,
                    label: t("titles.users_access_control"),
                    link: `${RouterPaths.USERACCESSCONTROL}`,
                },
                {
                    key: 5,
                    label: t("titles.role_permissions"),
                    link: `${RouterPaths.ROLE}`,
                },
                {
                    key: 6,
                    label: t("titles.permissions"),
                    link: `${RouterPaths.PERMISSIONS}`,
                },
                // { key: 6, label: t("titles.expire_all_passwords"), link: `${RouterPaths.EXPIREALLPASSWORDS}` },
                {
                    key: 7,
                    label: t("titles.action_history"),
                    link: `${RouterPaths.ACTIONHISTORY}`,
                },

                {
                    key: 200,
                    label: t("titles.registration_docs_rules"),
                    link: `${RouterPaths.REGISTRATIONDOCSRULES}`,
                },
            ],
        },
        {
            key: 8,
            label: t("titles.hr"),
            icon: <HRIcon width={20} height={20} />,
            children: [
                {
                    key: 9,
                    label: t("titles.employees"),
                    link: `${RouterPaths.EMPLOYEES}`,
                },
                {
                    key: 10,
                    label: t("titles.roles_associations"),
                    link: `${RouterPaths.ROLESASSOCIATIONS}`,
                },
                {
                    key: 11,
                    label: t("titles.academic_positions"),
                    link: RouterPaths.ACADEMICPOSITIONS,
                },
                {
                    key: 13,
                    label: t("titles.academic_working_hours"),
                    link: RouterPaths.POSITIONSWORKINGHOURS,
                },
            ],
        },

        {
            key: 90,
            label: t("titles.students_management"),
            icon: <StudentIcon width={20} height={20} />,
            children: [
                {
                    key: 111,
                    label: t("titles.students"),
                    link: RouterPaths.STUDENTS,
                },
                {
                    key: 113,
                    label: t(`titles.study_payment_options`),
                    link: RouterPaths.STUDYPAYMENTOPTIONS,
                },
            ],
        },
        {
            key: 14,
            label: t("titles.languages"),
            icon: <TranslationsIcon width={20} height={20} />,
            children: [
                {
                    key: 15,
                    label: t("titles.languages"),
                    link: `${RouterPaths.LANGUAGES}`,
                },
                {
                    key: 16,
                    label: t("titles.translation"),
                    link: `${RouterPaths.TRANSLATIONS}`,
                },
            ],
        },
        {
            key: 17,
            label: t("titles.educational_institution_structure"),
            icon: <EducationalIcon width={20} height={20} />,
            children: [
                {
                    key: 18,
                    label: t("titles.educational_degrees"),
                    link: `${RouterPaths.EDUCATIONALDEGREES}`,
                },
                {
                    key: 19,
                    label: t("titles.learning_format"),
                    link: `${RouterPaths.LEARNINGFORMAT}`,
                },
                {
                    key: 20,
                    label: t("titles.faculty"),
                    link: `${RouterPaths.FACULTY}`,
                },
                {
                    key: 21,
                    label: t("titles.academic_department"),
                    link: `${RouterPaths.ACADEMICDEPARTMENT}`,
                },
                {
                    key: 22,
                    label: t("titles.profession"),
                    link: `${RouterPaths.PROFESSION}`,
                },

                {
                    key: 23,
                    label: t("titles.subject"),
                    link: `${RouterPaths.SUBJECT}`,
                },
            ],
        },
        {
            key: 24,
            label: t("titles.educational_settings"),
            icon: <EducationalIcon width={20} height={20} />,
            children: [
                {
                    key: 25,
                    label: t("titles.academic_years"),
                    link: `${RouterPaths.ACADEMICYEAR}`,
                },
                {
                    key: 26,
                    label: t("titles.academic_terms"),
                    link: `${RouterPaths.ACADEMICTERM}`,
                },
                {
                    key: 27,
                    label: t("titles.study_years"),
                    link: `${RouterPaths.STUDYYEARS}`,
                },
                {
                    key: 28,
                    label: t("titles.teaching_format"),
                    link: `${RouterPaths.TEACHINGTYPE}`,
                },
                {
                    key: 29,
                    label: t("titles.subject_check_type"),
                    link: `${RouterPaths.SUBJECTCHECKTYPE}`,
                },
                {
                    key: 30,
                    label: t("titles.sectors"),
                    link: RouterPaths.EDUCATIONALSECTORS,
                },
                {
                    key: 31,
                    label: t("titles.educational_duration"),
                    link: RouterPaths.EDUCATIONALDURATION,
                },
                // { key: 29, label: t("titles.baseline_data"), link: `${RouterPaths.BASELINEDATA}` },
                // {
                //   key: 30,
                //   label: t("titles.baseline_data_setting"),
                //   link: `${RouterPaths.BASELINEDATASETTING}`,
                // },
                {
                    key: 33,
                    label: t("titles.qualification"),
                    link: `${RouterPaths.QUALIFICATION}`,
                },
                // {
                //   key: 32,
                //   label: t("titles.modular_subject"),
                //   link: `${RouterPaths.MODULARSUBJECT}`,
                // },
            ],
        },
        {
            key: 35,
            label: t("titles.learning_management"),
            icon: <LearningIcon width={20} height={20} />,
            children: [
                {
                    key: 36,
                    label: t("titles.learning_plan"),
                    link: `${RouterPaths.LEARNINGPLAN}`,
                },
                {
                    key: 37,
                    label: t("titles.baseline_data"),
                    link: `${RouterPaths.BASELINE}`,
                },

                {
                    key: 38,
                    label: t("titles.competencies"),
                    link: `${RouterPaths.COMPETENCES}`,
                },
                {
                    key: 39,
                    label: t("titles.educational_blocks"),
                    link: `${RouterPaths.EDUCATIONALBLOCKS}`,
                },
                {
                    key: 40,
                    label: t("titles.academic_structure"),
                    link: `${RouterPaths.ACADEMICSTRUCTURE}`,
                },
                {
                    key: 41,
                    label: t("titles.emp_workload"),
                    link: RouterPaths.WORKLOAD,
                },
                {
                    key: 42,
                    label: t("titles.academic_scheduling"),
                    link: RouterPaths.ACADEMICSCHEDULING,
                },
                {
                    key: 43,
                    label: t("titles.subject_groups"),
                    link: RouterPaths.SUBJECTGROUPS,
                },
                {
                    key: 44,
                    label: t("titles.united_lessons"),
                    link: RouterPaths.UNITEDLESSONS,
                },
                {
                    key: 45,
                    label: "Elective Subjects",
                    link: RouterPaths.ELECTIVESUBJECTS,
                },
            ],
        },
        {
            icon: <LearningIcon width={20} height={20} />,
            key: 88,
            label: t("titles.academic_timetable"),
            children: [
                {
                    key: 89,
                    label: t("titles.non_working_days"),
                    link: RouterPaths.NONWORKINGDAYS,
                },
                {
                    key: 91,
                    label: t("titles.academic_week_setup"),
                    link: RouterPaths.ACADEMICWEEKSETUP,
                },
            ],
        },
        {
            key: 46,
            label: t("titles.settings"),
            icon: <SettingsIcon width={20} height={20} />,
            children: [
                {
                    key: 47,
                    label: t("titles.password_policies"),
                    link: `${RouterPaths.PASSWORDPOLICIES}`,
                },
                {
                    key: 48,
                    label: t("titles.expire_all_passwords"),
                    link: `${RouterPaths.EXPIREALLPASSWORD}`,
                },
                // { key: 48, label: t("Institutional Preferences"), link: `${RouterPaths.INSTITUTIONALPREFERENCES}` },
            ],
        },
    ];
    const filteredMenuItems =
        role.toLowerCase() === "educator"
            ? menuItems
                  .filter(item => item.children?.some(child => child.key === 17))
                  .map(item => ({
                      ...item,
                      children: item.children?.filter(child => child.key === 17),
                  }))
            : role.toLowerCase() === "student" || role.toLowerCase() === "parent"
              ? []
              : menuItems;

    return filteredMenuItems;
};
